import {
     Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, OnInit, Input, OnChanges,
     ChangeDetectorRef, Directive, ContentChild, forwardRef, QueryList,
    } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-header-app',
    templateUrl: './header-app.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiHeaderAppComponent implements OnInit, OnChanges {

    @HostBinding('class') string = 'eui-header-app';

    @Input() appName = '';
    @Input() appShortName = '';
    @Input() appSubTitle = '';

    appNameFromState = '';
    appShortNameFromState = '';
    appSubTitleFromState = '';

    @ContentChild(forwardRef(() =>
        EuiHeaderAppNameDirective),
    ) customAppName: QueryList<EuiHeaderAppNameDirective>;

    @ContentChild(forwardRef(() =>
        EuiHeaderAppSubtitleDirective),
    ) customAppSubtitle: QueryList<EuiHeaderAppSubtitleDirective>;

    constructor(
        public asService: UxAppShellService,
        private ref: ChangeDetectorRef,
    ) {
        this.asService.state$.subscribe((state) => {
            this.appNameFromState = state.appName;
            this.appShortNameFromState = state.appShortName;
            this.appSubTitleFromState = state.appSubTitle;

            this.ref.markForCheck();
        });
    }

    ngOnInit() {
        this.asService.setState({
            ...this.asService.state,
            appName: this.appName,
            appShortName: this.appShortName,
            appSubTitle: this.appSubTitle,
        });
    }

    ngOnChanges() {
        if ( this.appShortName === '' ) {
            this.appShortName = this.appName;
        }
        this.asService.setState({
            ...this.asService.state,
            appName: this.appName,
            appShortName: this.appShortName,
            appSubTitle: this.appSubTitle,
        });
    }
}

/* tslint:disable */
@Directive({ selector: 'eui-header-app-name' })
export class EuiHeaderAppNameDirective { }
@Directive({ selector: 'eui-header-app-subtitle' })
export class EuiHeaderAppSubtitleDirective { }
/* tslint:enable */
